export default "__VITE_ASSET__C5g832YY__"